    import { databases } from "@/lib/appwrite";
    import { Query } from "appwrite";

    const databaseId = import.meta.env.VITE_APPWRITE_DATABASE_ID!;
    const sequencesCollectionId = import.meta.env.VITE_DATA_SEQUENCES_COLLECTION_ID!;
    const profilesCollectionId = import.meta.env.VITE_WORKER_PROFILE_COLLECTION_ID!;

    export async function generateReportCode(userId: string): Promise<{
        code: string;
        engineerLabel: string;
    }> {
        const [seqResult, profileResult] = await Promise.all([
            databases.listDocuments(databaseId, sequencesCollectionId),
            databases.listDocuments(databaseId, profilesCollectionId, [
                Query.equal("userId", userId),
            ]),
        ]);

        const seqDoc = seqResult.documents[0];
        const nextSeq: number = (seqDoc.technical_Report_Sequence ?? 0) + 1;

        const profile = profileResult.documents[0];
        const firstInitial = profile?.firstName?.[0]?.toUpperCase() ?? "X";
        const lastInitial = profile?.lastName?.[0]?.toUpperCase() ?? "X";

        const now = new Date();
        const yy = String(now.getFullYear()).slice(2);
        const mm = String(now.getMonth() + 1).padStart(2, "0");
        const dd = String(now.getDate()).padStart(2, "0");

        const code = `WIST-ST-${yy}${mm}${dd}-${String(nextSeq).padStart(4, "0")}-${firstInitial}${lastInitial}`;

        // const abbr = profile?.occupationAbbreviation ?? "";
        const firstName = profile?.firstName ?? "";
        const lastName = profile?.lastName ?? "";
        const engineerLabel = [firstName, lastName].filter(Boolean).join(" ") || userId;

        return { code, engineerLabel };
    }
    // Incrementa la secuencia al confirmar el guardado
    export async function incrementReportSequence(): Promise<void> {
        const seqResult = await databases.listDocuments(databaseId, sequencesCollectionId);
        const seqDoc = seqResult.documents[0];
        await databases.updateDocument(databaseId, sequencesCollectionId, seqDoc.$id, {
            technical_Report_Sequence: (seqDoc.technical_Report_Sequence ?? 0) + 1,
        });
    }

